<script setup lang="ts">
import markerSvg from '@/assets/about/marker.svg?raw'
import type { Props } from './type'

defineOptions({
  name: 'AboutInlineMarker',
})

defineProps<Props>()
</script>

<template>
  <span class="about-marker">
    <span class="about-marker__image" aria-hidden="true" v-html="markerSvg" />
    <span class="about-marker__content">
      <slot />
    </span>
  </span>
</template>

<style scoped>
.about-marker {
  position: relative;
  display: inline-block;
  overflow: visible;
}

.about-marker__image {
  position: absolute;
  bottom: -0.125rem;
  left: 0;
  width: 100%;
  height: 1.625rem;
  pointer-events: none;
}

.about-marker__image :deep(svg) {
  display: block;
  width: 100%;
  height: 100%;
}

.about-marker__content {
  position: relative;
}
</style>
